export default __webpack_public_path__ + "static/media/pic.8346caf3.png";